import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const DijkstrasAlgorithmModule = () => (
  <DMModuleSubtopic
    title="Dijkstra's Algorithm"
    videos={[
      "https://www.youtube.com/embed/n-0nyQ_RsaU"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "Apply Dijkstra's algorithm to find the shortest path between the vertices A and F in the given weighted connected graph G and compute the total weight of the obtained shortest path.",
        image:"/dm_37.png"
      },
      {image:"/dm_38.png"},
      {image:"/dm_39.png"},
      {image:"/dm_40.png"},
    ]}
    exampleVideos={[]}
  />
);

export default DijkstrasAlgorithmModule;
